import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface RecipeDeleteDialogProps {
  recipeTitle: string
  onCancel: () => void
  onConfirm: () => void
}

export function RecipeDeleteDialog({ recipeTitle, onCancel, onConfirm }: RecipeDeleteDialogProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-red-600">Recept verwijderen</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="mb-6 text-gray-600">
            Weet je zeker dat je "{recipeTitle}" wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.
          </p>
          <div className="flex gap-3">
            <Button variant="outline" onClick={onCancel} className="flex-1">
              Annuleren
            </Button>
            <Button onClick={onConfirm} className="flex-1 bg-red-600 hover:bg-red-700">
              Verwijderen
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
